import { useEffect, useRef } from 'react';
/**
 * Selected org stays in localStorage — not the central preferences service.
 * It is read before preferences hydrate to decide which orgId to pass into
 * hydrate; moving it into the service would create a chicken-and-egg
 * (need org to hydrate, need hydrate to know the org).
 */
const STORAGE_KEY = 'vectorhub:session:orgId';
/**
 * Restores the persisted org selection from localStorage once per userId.
 * Detects account switches (different userId without logout) and clears stale state.
 */
export function useUserSessionPersistence(userId, setCurrentOrgId) {
    const initializedRef = useRef(null);
    useEffect(() => {
        if (!userId) {
            initializedRef.current = null;
            return;
        }
        // Account switch without logout: clear stale org immediately.
        if (initializedRef.current !== null && initializedRef.current !== userId) {
            initializedRef.current = null;
            setCurrentOrgId(null);
        }
        if (initializedRef.current === userId)
            return;
        initializedRef.current = userId;
        if (typeof window !== 'undefined') {
            const stored = window.localStorage.getItem(STORAGE_KEY);
            if (stored)
                setCurrentOrgId(stored);
        }
    }, [userId, setCurrentOrgId]);
}
//# sourceMappingURL=useUserSessionPersistence.js.map